import { SET_LIST_EVENT, SET_IS_LOADING, SET_DICTIONARIES } from '../constants/listEvent';

const initialState = {
  listEvent: [],
  dictionaries: {
    chapters: [],
    categories: [],
    subCategories: [],
  },
  isLoading: false,
};

export default function listEvent(state = initialState, action) {
  switch (action.type) {
    case SET_LIST_EVENT:
      return {
        ...state,
        listEvent: action.payload.map((item, index) => ({
          ...item,
          serialNumber: index + 1,
        })),
      };
    case SET_DICTIONARIES:
      return {
        ...state,
        dictionaries: action.payload,
      };
    case SET_IS_LOADING:
      return { ...state, isLoading: action.payload };
    default:
      return state;
  }
}
